export interface NavItem {
  label: string
  href: string
}

export interface NavGroup {
  title: string
  items: NavItem[]
}

/** Primary header navigation. Home is reached via the logo, not listed here. */
export const primaryNav: NavItem[] = [
  { label: 'Play', href: '/play' },
  { label: 'Rules', href: '/rules' },
  { label: 'Acquire', href: '/acquire' },
]

export const footerNavGroups: NavGroup[] = [
  {
    title: 'Product',
    items: [
      { label: 'Play', href: '/play' },
      { label: 'Rules', href: '/rules' },
      { label: 'Acquire', href: '/acquire' },
    ],
  },
]
